import { ReactNode } from "react";
import { RegistryColorsProvider } from "./RegistryColorsContext";
import { UserRegistryProvider } from "./RegistryUserContext";

export const RegistryProviders = ({ children }: { children: ReactNode }) => {
   return (
      <RegistryColorsProvider>
         <UserRegistryProvider>{children}</UserRegistryProvider>
      </RegistryColorsProvider>
   );
};
